module.exports = __webpack_public_path__ + "static/img/checked-like-icon.96665529.png";